import { render, staticRenderFns } from "./MessageElement.vue?vue&type=template&id=19813e10&"
import script from "./MessageElement.vue?vue&type=script&lang=js&"
export * from "./MessageElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports